export default "__VITE_ASSET__DlP1qNPO__";